import { render } from "./RecipesList.vue?vue&type=template&id=414df280&scoped=true"
import script from "./RecipesList.vue?vue&type=script&lang=js"
export * from "./RecipesList.vue?vue&type=script&lang=js"

import "./RecipesList.vue?vue&type=style&index=0&id=414df280&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-414df280"

export default script